import type { ReactNode } from 'react';
import { Icone } from '@/shared/ui/icones';
import './cab-linha.css';

export type CabLinhaProps = {
  /** Quem: nome do contato, título do registro. Encolhe com ellipsis. */
  nome: string;
  /** O que vem antes do nome: o avatar (v3). */
  inicio?: ReactNode;
  /** Por onde: o glifo do canal. */
  canal?: ReactNode;
  /** A situação da conversa — ponto e palavra —, na linha abaixo do nome. */
  situacao?: ReactNode;
  /** Contato mascarado, caixa, canal. Some no celular. */
  meta?: string;
  /** Etiquetas. Somem no celular — estão no menu de ações. */
  etiquetas?: ReactNode;
  /** Canto direito: um selo de estado, UMA ação visível e o menu de ⋯. */
  direita?: ReactNode;
  /** Só no celular. Sem ela, o voltar não aparece. */
  aoVoltar?: () => void;
  /** Para onde volta, em palavras: "Voltar às conversas". */
  rotuloVoltar?: string;
};

/*
 * Duas linhas, como no desenho novo: o nome em cima; a situação e a meta
 * embaixo, em cinza. Antes era tudo numa linha só, e o nome disputava
 * espaço com "Integração · Canal API A02 · aberta em 26/09 às 08:51".
 */
export function CabLinha({
  nome,
  inicio,
  canal,
  situacao,
  meta,
  etiquetas,
  direita,
  aoVoltar,
  rotuloVoltar = 'Voltar',
}: CabLinhaProps) {
  return (
    <header className="cab-linha">
      {aoVoltar ? (
        <button
          type="button"
          className="cab-linha__voltar"
          onClick={aoVoltar}
          aria-label={rotuloVoltar}
        >
          {/* O mesmo desenho de antes, agora vindo da família — ver `icones.tsx`. */}
          <Icone nome="voltar" />
        </button>
      ) : null}
      {inicio ? <span className="cab-linha__inicio">{inicio}</span> : null}
      <span className="cab-linha__quem">
        <span className="cab-linha__titulo">
          <strong className="cab-linha__nome" title={nome}>
            {nome}
          </strong>
          {canal ? <span className="cab-linha__canal">{canal}</span> : null}
        </span>
        {situacao || meta ? (
          <span className="cab-linha__sub">
            {situacao ? <span className="cab-linha__situacao">{situacao}</span> : null}
            {meta ? (
              <span className="cab-linha__meta" title={meta}>
                {meta}
              </span>
            ) : null}
          </span>
        ) : null}
      </span>
      {etiquetas ? <span className="cab-linha__etiquetas">{etiquetas}</span> : null}
      {direita ? <span className="cab-linha__direita">{direita}</span> : null}
    </header>
  );
}
